import FeatureNaming from './services'

export default {
  setFeatureRename({ commit }, payload) {
    return new Promise((resolve, reject) => {
      return FeatureNaming.setFeatureRename(payload, commit)
        .then((response) => {
          resolve(response.data)
          let payload = response.data.renamed_features
          commit('SET_FEATURE_NAME', payload)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },
  fetchFeatureRename({ commit }, isUpper) {
    return new Promise((resolve, reject) => {
      FeatureNaming.fetchFeatureRename()
        .then((response) => {
          const renamedFeatures = response?.data?.renamed_features || []
          resolve(response.data)
          const upperLevel = renamedFeatures.filter((item) => item.is_upper_level)
          const lowerLevel = renamedFeatures.filter((item) => !item.is_upper_level)
          let payload
          if (!isUpper && lowerLevel.length === 0) {
            payload = upperLevel
          } else {
            payload = isUpper ? upperLevel : lowerLevel
          }
          commit('SET_FEATURE_NAME', payload)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },
}
